<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="UserId"
      ref="list"
      unit="用户"
      :expand-all-row="true"
      :page="false"
      :show-checkbox="true"
      :show-query="false"
      :query-params="params"
      :get-data-func="getDateFunc"
      urlHash="business/purchase/openingprice"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import tableColumn from "@/data/business/purchase/openingprice/list.json";

export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/pu/puGoodsPrice").default,
      params: {
        Name: "",
        LoginId: "",
        RoleId: null,
        Status: null,
      },
      tableList: [],
    };
  },

  methods: {
    getDateFunc() {
      return new Promise((resolve) => {
        this.api.list({ Code: "ProcessStage" }).then((res) => {
          this.tableList = JSON.parse(JSON.stringify(res.Data));
          resolve({ Data: res.Data, Count: res.Count, Code: res.Code });
        });
      });
    },
    //
    onExport(params={}) {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });
      this.api.export(params).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
